import { useEffect, useState } from "react";
import { Megaphone } from "lucide-react";
import api from "../lib/api";
import { HOLIDAYS } from "../lib/holidays";

// Site-wide scrolling announcement bar, configured from the admin console.
export default function AnnouncementBar() {
  const [cfg, setCfg] = useState(null);
  const [hol, setHol] = useState(window.__kvHoliday || null);
  useEffect(() => {
    const on = (e) => setHol(e.detail);
    window.addEventListener("kv-holiday", on);
    return () => window.removeEventListener("kv-holiday", on);
  }, []);

  useEffect(() => {
    let alive = true;
    api.get("/announcement").then(({ data }) => { if (alive) setCfg(data); }).catch(() => {});
    return () => { alive = false; };
  }, []);

  const h = hol?.greeting && hol.holiday ? HOLIDAYS[hol.holiday] : null;
  const text = cfg?.enabled ? cfg.text?.trim() : "";
  if (!text && !h) return null;

  const accent = h && !text ? h.colors[0] : cfg?.color || "#0066FF";
  const grad = h ? `linear-gradient(90deg, ${[...h.colors, h.colors[0]].join(", ")})` : null;
  // repeat the message so the marquee loops seamlessly (we animate -50%)
  const run = Array(6).fill(null);

  return (
    <div
      data-testid="announcement-bar"
      className="announce-bar relative z-[60] overflow-hidden border-b border-white/10"
      style={{ background: `linear-gradient(90deg, ${accent}1a, ${accent}33, ${accent}1a)` }}
    >
      <div className="relative flex items-center">
        <span className="shrink-0 flex items-center gap-1.5 pl-3 pr-2 py-1.5 text-white" style={{ color: accent }}>
          <Megaphone size={13} />
        </span>
        <div className="overflow-hidden flex-1 py-1.5">
          <div className="animate-marquee flex whitespace-nowrap" style={{ animationDuration: `${cfg?.speed || 30}s`, width: "max-content" }}>
            {run.map((_, i) => (
              <span key={i} className="mx-6 font-mono text-[12px] uppercase tracking-[0.18em] text-white/90">
                {h && <span data-testid={i === 0 ? "holiday-greeting" : undefined} className="kv-greeting font-bold" style={{ backgroundImage: grad }}>{h.greeting}</span>}
                {h && text && <span className="mx-4 text-white/40">•</span>}
                {text}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
